<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-word2.svg" can-back-flag="1"></Header>
    </header>

    <!--詳細-->
    <div id="wrapper">
      <div class="content">
        <div class="word-detail-box">
          <h3 class="ttl" v-html="title"></h3>
          <div class="text-box" v-html="content">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-word")
    $("body").addClass("page-word-detail")
    cmd.adjustStyle()
  },
  methods: {
    ...mapActions('WordModule', {
    }),
  },
  computed: {
    ...mapGetters('WordModule', {
      'title': 'title',
      'content': 'content',
    })
  },
  components: {
    Header
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/WordDetail.vue